export const techniqueConstants = Object.freeze({
    TECHNIQUES_LOADING: 'TECHNIQUES_LOADING',
    TECHNIQUES_LOAD_SUCCESS: 'TECHNIQUES_LOAD_SUCCESS',
    TECHNIQUES_LOAD_ERROR: 'TECHNIQUES_LOAD_ERROR'
});